<template>
  <div class="presence">
    <section class="section container">
      <h1 class="is-size-2-touch page-header">Business Presence</h1>
      <h3 class="page-subheader">
        Athena has worked closely with companies in the following sectors:
      </h3>
      <div id="industries">
        <div class="columns">
          <PresenceCard
            class="column"
            title="Architecture, Construction & Real Estate"
            icon="fas fa-home"
          />
          <PresenceCard class="column" title="Oil & Gas" icon="fas fa-tint" />
          <PresenceCard
            class="column"
            title="IT & Software"
            icon="fas fa-desktop"
          />
          <PresenceCard
            class="column"
            title="Hospitality & Travel"
            icon="fas fa-bed"
          />
        </div>
        <div class="columns">
          <PresenceCard
            class="column"
            title="Retail"
            icon="fas fa-shopping-cart"
          />
          <PresenceCard
            class="column"
            title="FMCG & Packaging"
            icon="fas fa-barcode"
          />
          <PresenceCard
            class="column"
            title="Electronics & Telecom"
            icon="fas fa-microchip"
          />
          <PresenceCard
            class="column"
            title="Supply Chain, Logistics & Shipping"
            icon="fas fa-shipping-fast"
          />
        </div>
        <div class="columns">
          <PresenceCard
            class="column"
            title="Banking & Finance"
            icon="fas fa-rupee-sign"
          />
          <PresenceCard class="column" title="Media" icon="fas fa-microphone" />
          <PresenceCard
            class="column"
            title="Healthcare"
            icon="fas fa-medkit"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PresenceCard from "@/components/PresenceCard.vue";

export default {
  name: "presence",
  components: {
    PresenceCard,
  },
};
</script>
